export default __webpack_public_path__ + "3ae4c4758ce8973528caa448e810971e.png";